import { HexColor } from './palette/colors';

type PrimitiveColorKey = `--color-${string}`;
type SemanticColorKey = `--semantic-${string}`;
type XcorColorKey =
  | `--data-${string}`
  | `--primary-${string}`
  | `--secondary-${string}`
  | `--bg-${string}`
  | `--syntax-tags-${string}`;

export const unityPrimitiveColorTokens = {
  '--color-brand-50': '#ebfef5',
  '--color-brand-100': '#dcfeed',
  '--color-brand-200': '#b4fdd8',
  '--color-brand-300': '#9cfccb',
  '--color-brand-400': '#83fcbf',
  '--color-brand-500': '#6afbb2',
  '--color-brand-600': '#4dffa6',
  '--color-brand-700': '#06e073',
  '--color-brand-800': '#04954d',
  '--color-brand-900': '#036333',
  '--color-brand-950': '#02311a',
  '--color-brand-1000': '#001f0f',
  '--color-red-50': '#fff5f6',
  '--color-red-100': '#ffdbe2',
  '--color-red-200': '#f8bec9',
  '--color-red-300': '#f5a3b1',
  '--color-red-400': '#fe8191',
  '--color-red-500': '#ff5271',
  '--color-red-600': '#ff3459',
  '--color-red-700': '#ff002e',
  '--color-red-800': '#cc0025',
  '--color-red-900': '#a6001e',
  '--color-red-950': '#410611',
  '--color-red-1000': '#310213',
  '--color-orange-50': '#fff6e6',
  '--color-orange-100': '#fff0d1',
  '--color-orange-200': '#ffe2a8',
  '--color-orange-300': '#ffd580',
  '--color-orange-400': '#ffc95c',
  '--color-orange-500': '#ffc042',
  '--color-orange-600': '#fead20',
  '--color-orange-700': '#e59900',
  '--color-orange-800': '#b27700',
  '--color-orange-900': '#805500',
  '--color-orange-950': '#4d3300',
  '--color-orange-1000': '#190d01',
  '--color-green-50': '#edfcf6',
  '--color-green-100': '#c5f6e2',
  '--color-green-200': '#a6efd3',
  '--color-green-300': '#84e9c4',
  '--color-green-400': '#5be1b5',
  '--color-green-500': '#26cf9f',
  '--color-green-600': '#16a17b',
  '--color-green-700': '#0e8a68',
  '--color-green-800': '#02724f',
  '--color-green-900': '#1e5743',
  '--color-green-950': '#182520',
  '--color-green-1000': '#011817',
  '--color-malibu-50': '#fbfcfe',
  '--color-malibu-100': '#f7f9fd',
  '--color-malibu-200': '#f3f6fc',
  '--color-malibu-300': '#e2eaf8',
  '--color-malibu-400': '#adc3eb',
  '--color-malibu-500': '#6c91da',
  '--color-malibu-600': '#4775d1',
  '--color-malibu-700': '#172d4f',
  '--color-malibu-800': '#142643',
  '--color-malibu-900': '#101f37',
  '--color-malibu-950': '#0b1525',
  '--color-malibu-1000': '#000a19',
  '--color-charcoal-50': '#eef3fc',
  '--color-charcoal-100': '#e5eefa',
  '--color-charcoal-200': '#d4e2f7',
  '--color-charcoal-300': '#b3c7e5',
  '--color-charcoal-400': '#8798b2',
  '--color-charcoal-500': '#5e6e88',
  '--color-charcoal-600': '#3d4d66',
  '--color-charcoal-700': '#344156',
  '--color-charcoal-800': '#303c50',
  '--color-charcoal-900': '#1f2938',
  '--color-charcoal-950': '#172130',
  '--color-charcoal-1000': '#181b25',
  '--color-purple-50': '#f1f0fe',
  '--color-purple-100': '#dbd8fd',
  '--color-purple-200': '#c4bffc',
  '--color-purple-300': '#aea7fb',
  '--color-purple-400': '#9c93fb',
  '--color-purple-500': '#8a80fa',
  '--color-purple-600': '#5e53de',
  '--color-purple-700': '#4b3eda',
  '--color-purple-800': '#3729d6',
  '--color-purple-900': '#2c21ab',
  '--color-purple-950': '#211980',
  '--color-purple-1000': '#161056',
  '--color-blue-50': '#e5f6ff',
  '--color-blue-100': '#ccedff',
  '--color-blue-200': '#a8e0ff',
  '--color-blue-300': '#8fd7ff',
  '--color-blue-400': '#66c8ff',
  '--color-blue-500': '#29b2ff',
  '--color-blue-600': '#0272b1',
  '--color-blue-700': '#025888',
  '--color-blue-800': '#004e7a',
  '--color-blue-900': '#003a5c',
  '--color-blue-950': '#002033',
  '--color-blue-1000': '#000d14',
  '--color-accent-palatinate-blue-50': '#e7ecfd',
  '--color-accent-palatinate-blue-100': '#d0d8fb',
  '--color-accent-palatinate-blue-200': '#a9b9fc',
  '--color-accent-palatinate-blue-300': '#7f98fa',
  '--color-accent-palatinate-blue-400': '#5576fa',
  '--color-accent-palatinate-blue-500': '#4064f5',
  '--color-accent-palatinate-blue-600': '#1d47f0',
  '--color-accent-palatinate-blue-700': '#0e2eaf',
  '--color-accent-palatinate-blue-800': '#0b268f',
  '--color-accent-palatinate-blue-900': '#081b68',
  '--color-accent-palatinate-blue-950': '#050c39',
  '--color-accent-palatinate-blue-1000': '#020618',
  '--color-accent-sushi-green-50': '#f1faeb',
  '--color-accent-sushi-green-100': '#e4f5d6',
  '--color-accent-sushi-green-200': '#d6f0c2',
  '--color-accent-sushi-green-300': '#bbe599',
  '--color-accent-sushi-green-400': '#a0db70',
  '--color-accent-sushi-green-500': '#85d147',
  '--color-accent-sushi-green-600': '#5b9c27',
  '--color-accent-sushi-green-700': '#487a1f',
  '--color-accent-sushi-green-800': '#345a16',
  '--color-accent-sushi-green-900': '#2b4912',
  '--color-accent-sushi-green-950': '#1d310c',
  '--color-accent-sushi-green-1000': '#0c1405',
  '--color-accent-royal-fuchsia-50': '#faebf4',
  '--color-accent-royal-fuchsia-100': '#f4d7ea',
  '--color-accent-royal-fuchsia-200': '#efc3df',
  '--color-accent-royal-fuchsia-300': '#e49bca',
  '--color-accent-royal-fuchsia-400': '#d964b0',
  '--color-accent-royal-fuchsia-500': '#ce4ba0',
  '--color-accent-royal-fuchsia-600': '#c33591',
  '--color-accent-royal-fuchsia-700': '#a02c77',
  '--color-accent-royal-fuchsia-800': '#842462',
  '--color-accent-royal-fuchsia-900': '#641b4b',
  '--color-accent-royal-fuchsia-950': '#3c102d',
  '--color-accent-royal-fuchsia-1000': '#14050f',
  '--color-accent-turquoise-50': '#f0fffe',
  '--color-accent-turquoise-100': '#d9fffd',
  '--color-accent-turquoise-200': '#bbfaf7',
  '--color-accent-turquoise-300': '#89faf4',
  '--color-accent-turquoise-400': '#15ede2',
  '--color-accent-turquoise-500': '#0cc9c0',
  '--color-accent-turquoise-600': '#089e96',
  '--color-accent-turquoise-700': '#00857e',
  '--color-accent-turquoise-800': '#006e68',
  '--color-accent-turquoise-900': '#004e52',
  '--color-accent-turquoise-950': '#003945',
  '--color-accent-turquoise-1000': '#00191f',
  '--color-accent-olive-50': '#fdfbe7',
  '--color-accent-olive-100': '#fbf8d0',
  '--color-accent-olive-200': '#f8f0a0',
  '--color-accent-olive-300': '#f4e971',
  '--color-accent-olive-400': '#e3d212',
  '--color-accent-olive-500': '#c7b70f',
  '--color-accent-olive-600': '#a1920c',
  '--color-accent-olive-700': '#686008',
  '--color-accent-olive-800': '#554f07',
  '--color-accent-olive-900': '#3e3905',
  '--color-accent-olive-950': '#2b2703',
  '--color-accent-olive-1000': '#131101',
  '--color-accent-vodka-50': '#efe9fc',
  '--color-accent-vodka-100': '#dfd3f8',
  '--color-accent-vodka-200': '#cebdf4',
  '--color-accent-vodka-300': '#bea7f1',
  '--color-accent-vodka-400': '#ae91ee',
  '--color-accent-vodka-500': '#8e65e7',
  '--color-accent-vodka-600': '#6e39e0',
  '--color-accent-vodka-700': '#541fc6',
  '--color-accent-vodka-800': '#41189a',
  '--color-accent-vodka-900': '#2f116e',
  '--color-accent-vodka-950': '#160835',
  '--color-accent-vodka-1000': '#090316',
  '--color-accent-orchid-50': '#f6e7fe',
  '--color-accent-orchid-100': '#edcffc',
  '--color-accent-orchid-200': '#e4b6fb',
  '--color-accent-orchid-300': '#db9efa',
  '--color-accent-orchid-400': '#ce7cf7',
  '--color-accent-orchid-500': '#c44dff',
  '--color-accent-orchid-600': '#a60df2',
  '--color-accent-orchid-700': '#850ac2',
  '--color-accent-orchid-800': '#640891',
  '--color-accent-orchid-900': '#530679',
  '--color-accent-orchid-950': '#28033a',
  '--color-accent-orchid-1000': '#110118',
  '--color-accent-raspberry-50': '#fde7ef',
  '--color-accent-raspberry-100': '#fdcedf',
  '--color-accent-raspberry-200': '#fbb6ce',
  '--color-accent-raspberry-300': '#fa9ebe',
  '--color-accent-raspberry-400': '#f76e9d',
  '--color-accent-raspberry-500': '#f53d7d',
  '--color-accent-raspberry-600': '#e90c59',
  '--color-accent-raspberry-700': '#c20a4a',
  '--color-accent-raspberry-800': '#920738',
  '--color-accent-raspberry-900': '#610525',
  '--color-accent-raspberry-950': '#310213',
  '--color-accent-raspberry-1000': '#19010a',
  '--color-accent-sky-blue-50': '#ebf7ff',
  '--color-accent-sky-blue-100': '#d6f2ff',
  '--color-accent-sky-blue-200': '#a2cef5',
  '--color-accent-sky-blue-300': '#89c2f5',
  '--color-accent-sky-blue-400': '#75bfff',
  '--color-accent-sky-blue-500': '#5cb2ff',
  '--color-accent-sky-blue-600': '#2d91eb',
  '--color-accent-sky-blue-700': '#0f84ec',
  '--color-accent-sky-blue-800': '#1170cf',
  '--color-accent-sky-blue-900': '#144b81',
  '--color-accent-sky-blue-950': '#092d51',
  '--color-accent-sky-blue-1000': '#001326',
  '--color-accent-pink-flamingo-50': '#ffe5fa',
  '--color-accent-pink-flamingo-100': '#ffccf6',
  '--color-accent-pink-flamingo-200': '#faaaeb',
  '--color-accent-pink-flamingo-300': '#fa91e6',
  '--color-accent-pink-flamingo-400': '#f576dd',
  '--color-accent-pink-flamingo-500': '#eb5bd0',
  '--color-accent-pink-flamingo-600': '#e043c3',
  '--color-accent-pink-flamingo-700': '#d415b0',
  '--color-accent-pink-flamingo-800': '#b80496',
  '--color-accent-pink-flamingo-900': '#7c0366',
  '--color-accent-pink-flamingo-950': '#4b023d',
  '--color-accent-pink-flamingo-1000': '#190114',
  '--color-accent-persimmon-50': '#fff2eb',
  '--color-accent-persimmon-100': '#ffe1d1',
  '--color-accent-persimmon-200': '#ffc7a8',
  '--color-accent-persimmon-300': '#ffad80',
  '--color-accent-persimmon-400': '#ff8b4d',
  '--color-accent-persimmon-500': '#ff6a1a',
  '--color-accent-persimmon-600': '#e55000',
  '--color-accent-persimmon-700': '#ce5000',
  '--color-accent-persimmon-800': '#993600',
  '--color-accent-persimmon-900': '#662400',
  '--color-accent-persimmon-950': '#331200',
  '--color-accent-persimmon-1000': '#1a0900',
  '--color-accent-maximum-yellow-50': '#fdfeec',
  '--color-accent-maximum-yellow-100': '#fafdd3',
  '--color-accent-maximum-yellow-200': '#f7fca9',
  '--color-accent-maximum-yellow-300': '#ebf28c',
  '--color-accent-maximum-yellow-400': '#e3ed5a',
  '--color-accent-maximum-yellow-500': '#c7d140',
  '--color-accent-maximum-yellow-600': '#8f9408',
  '--color-accent-maximum-yellow-700': '#7b8007',
  '--color-accent-maximum-yellow-800': '#6a6e06',
  '--color-accent-maximum-yellow-900': '#595c05',
  '--color-accent-maximum-yellow-950': '#404203',
  '--color-accent-maximum-yellow-1000': '#171801',
  '--color-accent-rackley-50': '#eef2f6',
  '--color-accent-rackley-100': '#dee4ed',
  '--color-accent-rackley-200': '#c7d1e1',
  '--color-accent-rackley-300': '#acbcd2',
  '--color-accent-rackley-400': '#8ba1c1',
  '--color-accent-rackley-500': '#748eb4',
  '--color-accent-rackley-600': '#5a79a6',
  '--color-accent-rackley-700': '#476085',
  '--color-accent-rackley-800': '#3e5474',
  '--color-accent-rackley-900': '#2d3c53',
  '--color-accent-rackley-950': '#1b2432',
  '--color-accent-rackley-1000': '#090c11',
  '--color-accent-dusty-gray-50': '#f1f1f3',
  '--color-accent-dusty-gray-100': '#e3e3e8',
  '--color-accent-dusty-gray-200': '#d5d5dc',
  '--color-accent-dusty-gray-300': '#c7c7d1',
  '--color-accent-dusty-gray-400': '#abacba',
  '--color-accent-dusty-gray-500': '#8f90a3',
  '--color-accent-dusty-gray-600': '#73748c',
  '--color-accent-dusty-gray-700': '#5c5d70',
  '--color-accent-dusty-gray-800': '#40404e',
  '--color-accent-dusty-gray-900': '#2e2e38',
  '--color-accent-dusty-gray-950': '#1c1c22',
  '--color-accent-dusty-gray-1000': '#0c0c0e',
} satisfies Record<PrimitiveColorKey, HexColor>;

const _unusedUnitySemanticDarkColorTokens = {
  // semantic / bg / accent
  '--semantic-bg-accent-ai-bold': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  '--semantic-bg-accent-ai-subtle': unityPrimitiveColorTokens['--color-accent-turquoise-950'],
  '--semantic-bg-accent-ai-subtle-hover': unityPrimitiveColorTokens['--color-accent-turquoise-900'],
  '--semantic-bg-accent-dusty-gray-bold': unityPrimitiveColorTokens['--color-accent-dusty-gray-700'],
  '--semantic-bg-accent-dusty-gray-subtle': unityPrimitiveColorTokens['--color-accent-dusty-gray-950'],
  '--semantic-bg-accent-dusty-gray-subtle-hover': unityPrimitiveColorTokens['--color-accent-dusty-gray-900'],
  '--semantic-bg-accent-max-yellow-bold': unityPrimitiveColorTokens['--color-accent-maximum-yellow-700'],
  '--semantic-bg-accent-max-yellow-subtle': unityPrimitiveColorTokens['--color-accent-maximum-yellow-950'],
  '--semantic-bg-accent-max-yellow-subtle-hover': unityPrimitiveColorTokens['--color-accent-maximum-yellow-900'],
  '--semantic-bg-accent-olive-bold': unityPrimitiveColorTokens['--color-accent-olive-700'],
  '--semantic-bg-accent-olive-subtle': unityPrimitiveColorTokens['--color-accent-olive-950'],
  '--semantic-bg-accent-olive-subtle-hover': unityPrimitiveColorTokens['--color-accent-olive-900'],
  '--semantic-bg-accent-orchid-bold': unityPrimitiveColorTokens['--color-accent-orchid-700'],
  '--semantic-bg-accent-orchid-subtle': unityPrimitiveColorTokens['--color-accent-orchid-950'],
  '--semantic-bg-accent-orchid-subtle-hover': unityPrimitiveColorTokens['--color-accent-orchid-900'],
  '--semantic-bg-accent-palatinate-blue-bold': unityPrimitiveColorTokens['--color-accent-palatinate-blue-700'],
  '--semantic-bg-accent-palatinate-blue-subtle': unityPrimitiveColorTokens['--color-accent-palatinate-blue-950'],
  '--semantic-bg-accent-palatinate-blue-subtle-hover': unityPrimitiveColorTokens['--color-accent-palatinate-blue-900'],
  '--semantic-bg-accent-persimmon-bold': unityPrimitiveColorTokens['--color-accent-persimmon-700'],
  '--semantic-bg-accent-persimmon-subtle': unityPrimitiveColorTokens['--color-accent-persimmon-950'],
  '--semantic-bg-accent-persimmon-subtle-hover': unityPrimitiveColorTokens['--color-accent-persimmon-900'],
  '--semantic-bg-accent-pink-flamingo-bold': unityPrimitiveColorTokens['--color-accent-pink-flamingo-700'],
  '--semantic-bg-accent-pink-flamingo-subtle': unityPrimitiveColorTokens['--color-accent-pink-flamingo-950'],
  '--semantic-bg-accent-pink-flamingo-subtle-hover': unityPrimitiveColorTokens['--color-accent-pink-flamingo-900'],
  '--semantic-bg-accent-rackley-bold': unityPrimitiveColorTokens['--color-accent-rackley-700'],
  '--semantic-bg-accent-rackley-subtle': unityPrimitiveColorTokens['--color-accent-rackley-950'],
  '--semantic-bg-accent-rackley-subtle-hover': unityPrimitiveColorTokens['--color-accent-rackley-900'],
  '--semantic-bg-accent-raspberry-bold': unityPrimitiveColorTokens['--color-accent-raspberry-700'],
  '--semantic-bg-accent-raspberry-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-950'],
  '--semantic-bg-accent-raspberry-subtle-hover': unityPrimitiveColorTokens['--color-accent-raspberry-900'],
  '--semantic-bg-accent-royal-fuchsia-bold': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-700'],
  '--semantic-bg-accent-royal-fuchsia-subtle': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-950'],
  '--semantic-bg-accent-royal-fuchsia-subtle-hover': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-900'],
  '--semantic-bg-accent-sky-blue-bold': unityPrimitiveColorTokens['--color-accent-sky-blue-700'],
  '--semantic-bg-accent-sky-blue-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-950'],
  '--semantic-bg-accent-sky-blue-subtle-hover': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--semantic-bg-accent-sushi-green-bold': unityPrimitiveColorTokens['--color-accent-sushi-green-700'],
  '--semantic-bg-accent-sushi-green-subtle': unityPrimitiveColorTokens['--color-accent-sushi-green-950'],
  '--semantic-bg-accent-sushi-green-subtle-hover': unityPrimitiveColorTokens['--color-accent-sushi-green-900'],
  '--semantic-bg-accent-vodka-bold': unityPrimitiveColorTokens['--color-accent-vodka-700'],
  '--semantic-bg-accent-vodka-subtle': unityPrimitiveColorTokens['--color-accent-vodka-950'],
  '--semantic-bg-accent-vodka-subtle-hover': unityPrimitiveColorTokens['--color-accent-vodka-900'],
  // semantic / bg / input
  '--semantic-bg-input-hover': unityPrimitiveColorTokens['--color-charcoal-600'],
  '--semantic-bg-input-inverse-active': unityPrimitiveColorTokens['--color-malibu-100'],
  '--semantic-bg-input-inverse-disabled': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-bg-input-micro': unityPrimitiveColorTokens['--color-charcoal-500'],
  '--semantic-bg-input-micro-active': unityPrimitiveColorTokens['--color-charcoal-900'],
  '--semantic-bg-input-micro-disabled': unityPrimitiveColorTokens['--color-charcoal-950'],
  '--semantic-bg-input-micro-hover': unityPrimitiveColorTokens['--color-charcoal-400'],
  // semantic / bg / interactive / ai
  '--semantic-bg-interactive-ai-active': unityPrimitiveColorTokens['--color-accent-turquoise-800'],
  '--semantic-bg-interactive-ai-default': unityPrimitiveColorTokens['--color-accent-turquoise-950'],
  '--semantic-bg-interactive-ai-default-end': unityPrimitiveColorTokens['--color-blue-500'],
  '--semantic-bg-interactive-ai-default-end-hover': unityPrimitiveColorTokens['--color-blue-400'],
  '--semantic-bg-interactive-ai-default-start': unityPrimitiveColorTokens['--color-accent-turquoise-400'],
  '--semantic-bg-interactive-ai-default-start-hover': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  '--semantic-bg-interactive-ai-disabled': unityPrimitiveColorTokens['--color-charcoal-950'],
  '--semantic-bg-interactive-ai-hover': unityPrimitiveColorTokens['--color-accent-turquoise-900'],
  '--semantic-bg-interactive-ai-subtle-end': unityPrimitiveColorTokens['--color-blue-900'],
  '--semantic-bg-interactive-ai-subtle-start': unityPrimitiveColorTokens['--color-accent-turquoise-900'],
  '--semantic-bg-interactive-ai-subtle-start-end': unityPrimitiveColorTokens['--color-blue-800'],
  '--semantic-bg-interactive-ai-subtle-start-hover': unityPrimitiveColorTokens['--color-accent-turquoise-800'],
  // semantic / bg / interactive / destructive
  '--semantic-bg-interactive-destructive-active': unityPrimitiveColorTokens['--color-red-700'],
  '--semantic-bg-interactive-destructive-subtle-active': unityPrimitiveColorTokens['--color-red-1000'],
  '--semantic-bg-interactive-destructive-subtle-disabled': unityPrimitiveColorTokens['--color-charcoal-950'],
  '--semantic-bg-interactive-destructive-subtle-hover': unityPrimitiveColorTokens['--color-red-950'],
  // semantic / bg / interactive / highlight
  '--semantic-bg-interactive-highlight-active': unityPrimitiveColorTokens['--color-brand-300'],
  '--semantic-bg-interactive-highlight-disabled': unityPrimitiveColorTokens['--color-brand-950'],
  // semantic / bg / interactive / inverse
  '--semantic-bg-interactive-inverse-active': unityPrimitiveColorTokens['--color-malibu-100'],
  '--semantic-bg-interactive-inverse-default': unityPrimitiveColorTokens['--color-malibu-50'],
  '--semantic-bg-interactive-inverse-disabled': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-bg-interactive-inverse-hover': unityPrimitiveColorTokens['--color-malibu-300'],
  // semantic / bg / status
  '--semantic-bg-status-destructive': unityPrimitiveColorTokens['--color-red-600'],
  '--semantic-bg-status-destructive-subtle': unityPrimitiveColorTokens['--color-red-1000'],
  '--semantic-bg-status-highlight-subtle': unityPrimitiveColorTokens['--color-brand-1000'],
  '--semantic-bg-status-info': unityPrimitiveColorTokens['--color-blue-500'],
  '--semantic-bg-status-info-subtle': unityPrimitiveColorTokens['--color-blue-950'],
  '--semantic-bg-status-neutral': unityPrimitiveColorTokens['--color-charcoal-700'],
  '--semantic-bg-status-neutral-subtle': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--semantic-bg-status-success': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-bg-status-success-subtle': unityPrimitiveColorTokens['--color-green-1000'],
  '--semantic-bg-status-warning': unityPrimitiveColorTokens['--color-orange-500'],
  '--semantic-bg-status-warning-subtle': unityPrimitiveColorTokens['--color-orange-1000'],
  // semantic / bg / surface
  '--semantic-bg-surface-ai-end': unityPrimitiveColorTokens['--color-accent-turquoise-950'],
  '--semantic-bg-surface-content-shell': unityPrimitiveColorTokens['--color-charcoal-950'],
  // semantic / border
  '--semantic-border-destructive': unityPrimitiveColorTokens['--color-red-700'],
  '--semantic-border-destructive-hover': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-border-destructive-subtle': unityPrimitiveColorTokens['--color-red-900'],
  '--semantic-border-highlight': unityPrimitiveColorTokens['--color-brand-600'],
  '--semantic-border-info': unityPrimitiveColorTokens['--color-blue-800'],
  '--semantic-border-selected': unityPrimitiveColorTokens['--color-purple-500'],
  '--semantic-border-subtle': unityPrimitiveColorTokens['--color-charcoal-900'],
  '--semantic-border-success': unityPrimitiveColorTokens['--color-green-900'],
  '--semantic-border-warning': unityPrimitiveColorTokens['--color-orange-900'],
  // semantic / border / accent
  '--semantic-border-accent-ai-subtle': unityPrimitiveColorTokens['--color-accent-turquoise-700'],
  '--semantic-border-accent-max-yellow-subtle': unityPrimitiveColorTokens['--color-accent-maximum-yellow-900'],
  '--semantic-border-accent-olive-subtle': unityPrimitiveColorTokens['--color-accent-olive-900'],
  '--semantic-border-accent-orchid-subtle': unityPrimitiveColorTokens['--color-accent-orchid-900'],
  '--semantic-border-accent-palatinate-blue-subtle': unityPrimitiveColorTokens['--color-accent-palatinate-blue-900'],
  '--semantic-border-accent-persimmon-subtle': unityPrimitiveColorTokens['--color-accent-persimmon-900'],
  '--semantic-border-accent-pink-flamingo-subtle': unityPrimitiveColorTokens['--color-accent-pink-flamingo-900'],
  '--semantic-border-accent-rackley-subtle': unityPrimitiveColorTokens['--color-accent-rackley-900'],
  '--semantic-border-accent-raspberry-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-900'],
  '--semantic-border-accent-royal-fuchsia-subtle': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-900'],
  '--semantic-border-accent-skyblue-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--semantic-border-accent-sushi-green-subtle': unityPrimitiveColorTokens['--color-accent-sushi-green-900'],
  '--semantic-border-accent-vodka-subtle': unityPrimitiveColorTokens['--color-accent-vodka-900'],
  // semantic / border / interactive
  '--semantic-border-interactive-ai-start': unityPrimitiveColorTokens['--color-accent-turquoise-300'],
  // semantic / data / informative
  '--semantic-data-informative-unknown': unityPrimitiveColorTokens['--color-accent-dusty-gray-300'],
  // semantic / data / severity
  '--semantic-data-severity-critical': unityPrimitiveColorTokens['--color-red-700'],
  '--semantic-data-severity-critical-subtle': unityPrimitiveColorTokens['--color-red-950'],
  '--semantic-data-severity-high': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-data-severity-high-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-950'],
  '--semantic-data-severity-info': unityPrimitiveColorTokens['--color-accent-dusty-gray-300'],
  '--semantic-data-severity-info-subtle': unityPrimitiveColorTokens['--color-accent-dusty-gray-950'],
  '--semantic-data-severity-low': unityPrimitiveColorTokens['--color-accent-sky-blue-600'],
  '--semantic-data-severity-low-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-950'],
  '--semantic-data-severity-mid': unityPrimitiveColorTokens['--color-orange-600'],
  '--semantic-data-severity-mid-subtle': unityPrimitiveColorTokens['--color-orange-950'],
  '--semantic-data-severity-neutral': unityPrimitiveColorTokens['--color-charcoal-600'],
  // semantic / text
  '--semantic-text-ai-highlight': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  '--semantic-text-highlight': unityPrimitiveColorTokens['--color-brand-600'],
  '--semantic-text-link': unityPrimitiveColorTokens['--color-blue-500'],
  '--semantic-text-link-hover': unityPrimitiveColorTokens['--color-blue-300'],
  '--semantic-text-success': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-text-warning': unityPrimitiveColorTokens['--color-orange-600'],
  // semantic / text / accent
  '--semantic-text-accent-ai': unityPrimitiveColorTokens['--color-accent-turquoise-100'],
  '--semantic-text-accent-max-yellow': unityPrimitiveColorTokens['--color-accent-maximum-yellow-100'],
  '--semantic-text-accent-olive': unityPrimitiveColorTokens['--color-accent-olive-100'],
  '--semantic-text-accent-orchid': unityPrimitiveColorTokens['--color-accent-orchid-100'],
  '--semantic-text-accent-palatinate-blue': unityPrimitiveColorTokens['--color-accent-palatinate-blue-100'],
  '--semantic-text-accent-persimmon': unityPrimitiveColorTokens['--color-accent-persimmon-100'],
  '--semantic-text-accent-pink-flamingo': unityPrimitiveColorTokens['--color-accent-pink-flamingo-100'],
  '--semantic-text-accent-rackley': unityPrimitiveColorTokens['--color-accent-rackley-100'],
  '--semantic-text-accent-raspberry': unityPrimitiveColorTokens['--color-accent-raspberry-100'],
  '--semantic-text-accent-royal-fuchsia': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-100'],
  '--semantic-text-accent-skyblue': unityPrimitiveColorTokens['--color-accent-sky-blue-100'],
  '--semantic-text-accent-sushi-green': unityPrimitiveColorTokens['--color-accent-sushi-green-100'],
  '--semantic-text-accent-vodka': unityPrimitiveColorTokens['--color-accent-vodka-100'],
} satisfies Record<string, HexColor>;

const _unusedUnitySemanticLightColorTokens = {
  // semantic / bg / accent
  '--semantic-bg-accent-ai-bold': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  '--semantic-bg-accent-ai-subtle': unityPrimitiveColorTokens['--color-accent-turquoise-50'],
  '--semantic-bg-accent-ai-subtle-hover': unityPrimitiveColorTokens['--color-accent-turquoise-100'],
  '--semantic-bg-accent-dusty-gray-bold': unityPrimitiveColorTokens['--color-accent-dusty-gray-400'],
  '--semantic-bg-accent-dusty-gray-subtle': unityPrimitiveColorTokens['--color-accent-dusty-gray-50'],
  '--semantic-bg-accent-dusty-gray-subtle-hover': unityPrimitiveColorTokens['--color-accent-dusty-gray-100'],
  '--semantic-bg-accent-max-yellow-bold': unityPrimitiveColorTokens['--color-accent-maximum-yellow-400'],
  '--semantic-bg-accent-max-yellow-subtle': unityPrimitiveColorTokens['--color-accent-maximum-yellow-50'],
  '--semantic-bg-accent-max-yellow-subtle-hover': unityPrimitiveColorTokens['--color-accent-maximum-yellow-100'],
  '--semantic-bg-accent-olive-bold': unityPrimitiveColorTokens['--color-accent-olive-400'],
  '--semantic-bg-accent-olive-subtle': unityPrimitiveColorTokens['--color-accent-olive-50'],
  '--semantic-bg-accent-olive-subtle-hover': unityPrimitiveColorTokens['--color-accent-olive-100'],
  '--semantic-bg-accent-orchid-bold': unityPrimitiveColorTokens['--color-accent-orchid-400'],
  '--semantic-bg-accent-orchid-subtle': unityPrimitiveColorTokens['--color-accent-orchid-50'],
  '--semantic-bg-accent-orchid-subtle-hover': unityPrimitiveColorTokens['--color-accent-orchid-100'],
  '--semantic-bg-accent-palatinate-blue-bold': unityPrimitiveColorTokens['--color-accent-palatinate-blue-400'],
  '--semantic-bg-accent-palatinate-blue-subtle': unityPrimitiveColorTokens['--color-accent-palatinate-blue-50'],
  '--semantic-bg-accent-palatinate-blue-subtle-hover': unityPrimitiveColorTokens['--color-accent-palatinate-blue-100'],
  '--semantic-bg-accent-persimmon-bold': unityPrimitiveColorTokens['--color-accent-persimmon-400'],
  '--semantic-bg-accent-persimmon-subtle': unityPrimitiveColorTokens['--color-accent-persimmon-50'],
  '--semantic-bg-accent-persimmon-subtle-hover': unityPrimitiveColorTokens['--color-accent-persimmon-100'],
  '--semantic-bg-accent-pink-flamingo-bold': unityPrimitiveColorTokens['--color-accent-pink-flamingo-400'],
  '--semantic-bg-accent-pink-flamingo-subtle': unityPrimitiveColorTokens['--color-accent-pink-flamingo-50'],
  '--semantic-bg-accent-pink-flamingo-subtle-hover': unityPrimitiveColorTokens['--color-accent-pink-flamingo-100'],
  '--semantic-bg-accent-rackley-bold': unityPrimitiveColorTokens['--color-accent-rackley-400'],
  '--semantic-bg-accent-rackley-subtle': unityPrimitiveColorTokens['--color-accent-rackley-50'],
  '--semantic-bg-accent-rackley-subtle-hover': unityPrimitiveColorTokens['--color-accent-rackley-100'],
  '--semantic-bg-accent-raspberry-bold': unityPrimitiveColorTokens['--color-accent-raspberry-400'],
  '--semantic-bg-accent-raspberry-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-50'],
  '--semantic-bg-accent-raspberry-subtle-hover': unityPrimitiveColorTokens['--color-accent-raspberry-100'],
  '--semantic-bg-accent-royal-fuchsia-bold': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-400'],
  '--semantic-bg-accent-royal-fuchsia-subtle': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-50'],
  '--semantic-bg-accent-royal-fuchsia-subtle-hover': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-100'],
  '--semantic-bg-accent-sky-blue-bold': unityPrimitiveColorTokens['--color-accent-sky-blue-400'],
  '--semantic-bg-accent-sky-blue-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-50'],
  '--semantic-bg-accent-sky-blue-subtle-hover': unityPrimitiveColorTokens['--color-accent-sky-blue-100'],
  '--semantic-bg-accent-sushi-green-bold': unityPrimitiveColorTokens['--color-accent-sushi-green-400'],
  '--semantic-bg-accent-sushi-green-subtle': unityPrimitiveColorTokens['--color-accent-sushi-green-50'],
  '--semantic-bg-accent-sushi-green-subtle-hover': unityPrimitiveColorTokens['--color-accent-sushi-green-100'],
  '--semantic-bg-accent-vodka-bold': unityPrimitiveColorTokens['--color-accent-vodka-400'],
  '--semantic-bg-accent-vodka-subtle': unityPrimitiveColorTokens['--color-accent-vodka-50'],
  '--semantic-bg-accent-vodka-subtle-hover': unityPrimitiveColorTokens['--color-accent-vodka-100'],
  // semantic / bg / input
  '--semantic-bg-input-hover': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--semantic-bg-input-inverse-active': unityPrimitiveColorTokens['--color-malibu-700'],
  '--semantic-bg-input-inverse-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-input-micro': unityPrimitiveColorTokens['--color-charcoal-300'],
  '--semantic-bg-input-micro-active': unityPrimitiveColorTokens['--color-charcoal-300'],
  '--semantic-bg-input-micro-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-input-micro-hover': unityPrimitiveColorTokens['--color-charcoal-50'],
  // semantic / bg / interactive / ai
  '--semantic-bg-interactive-ai-active': unityPrimitiveColorTokens['--color-accent-turquoise-300'],
  '--semantic-bg-interactive-ai-default': unityPrimitiveColorTokens['--color-accent-turquoise-100'],
  '--semantic-bg-interactive-ai-default-end': unityPrimitiveColorTokens['--color-blue-500'],
  '--semantic-bg-interactive-ai-default-end-hover': unityPrimitiveColorTokens['--color-blue-400'],
  '--semantic-bg-interactive-ai-default-start': unityPrimitiveColorTokens['--color-accent-turquoise-400'],
  '--semantic-bg-interactive-ai-default-start-hover': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  '--semantic-bg-interactive-ai-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-interactive-ai-hover': unityPrimitiveColorTokens['--color-accent-turquoise-200'],
  '--semantic-bg-interactive-ai-subtle-end': unityPrimitiveColorTokens['--color-blue-100'],
  '--semantic-bg-interactive-ai-subtle-start': unityPrimitiveColorTokens['--color-accent-turquoise-200'],
  '--semantic-bg-interactive-ai-subtle-start-end': unityPrimitiveColorTokens['--color-blue-300'],
  '--semantic-bg-interactive-ai-subtle-start-hover': unityPrimitiveColorTokens['--color-accent-turquoise-300'],
  // semantic / bg / interactive / destructive
  '--semantic-bg-interactive-destructive-active': unityPrimitiveColorTokens['--color-red-700'],
  '--semantic-bg-interactive-destructive-subtle-active': unityPrimitiveColorTokens['--color-red-50'],
  '--semantic-bg-interactive-destructive-subtle-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-interactive-destructive-subtle-hover': unityPrimitiveColorTokens['--color-red-100'],
  // semantic / bg / interactive / highlight
  '--semantic-bg-interactive-highlight-active': unityPrimitiveColorTokens['--color-charcoal-700'],
  '--semantic-bg-interactive-highlight-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  // semantic / bg / interactive / inverse
  '--semantic-bg-interactive-inverse-active': unityPrimitiveColorTokens['--color-malibu-700'],
  '--semantic-bg-interactive-inverse-default': unityPrimitiveColorTokens['--color-malibu-900'],
  '--semantic-bg-interactive-inverse-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-interactive-inverse-hover': unityPrimitiveColorTokens['--color-malibu-800'],
  // semantic / bg / status
  '--semantic-bg-status-destructive': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-bg-status-destructive-subtle': unityPrimitiveColorTokens['--color-red-50'],
  '--semantic-bg-status-highlight-subtle': unityPrimitiveColorTokens['--color-brand-50'],
  '--semantic-bg-status-info': unityPrimitiveColorTokens['--color-accent-sky-blue-500'],
  '--semantic-bg-status-info-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-50'],
  '--semantic-bg-status-neutral': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-status-neutral-subtle': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--semantic-bg-status-success': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-bg-status-success-subtle': unityPrimitiveColorTokens['--color-green-50'],
  '--semantic-bg-status-warning': unityPrimitiveColorTokens['--color-orange-500'],
  '--semantic-bg-status-warning-subtle': unityPrimitiveColorTokens['--color-orange-50'],
  // semantic / bg / surface
  '--semantic-bg-surface-ai-end': unityPrimitiveColorTokens['--color-accent-turquoise-100'],
  '--semantic-bg-surface-content-shell': unityPrimitiveColorTokens['--color-malibu-100'],
  // semantic / border
  '--semantic-border-destructive': unityPrimitiveColorTokens['--color-red-700'],
  '--semantic-border-destructive-hover': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-border-destructive-subtle': unityPrimitiveColorTokens['--color-red-100'],
  '--semantic-border-highlight': unityPrimitiveColorTokens['--color-brand-700'],
  '--semantic-border-info': unityPrimitiveColorTokens['--color-blue-500'],
  '--semantic-border-selected': unityPrimitiveColorTokens['--color-purple-600'],
  '--semantic-border-subtle': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--semantic-border-success': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-border-warning': unityPrimitiveColorTokens['--color-orange-500'],
  // semantic / border / accent
  '--semantic-border-accent-ai-subtle': unityPrimitiveColorTokens['--color-accent-turquoise-400'],
  '--semantic-border-accent-max-yellow-subtle': unityPrimitiveColorTokens['--color-accent-maximum-yellow-100'],
  '--semantic-border-accent-olive-subtle': unityPrimitiveColorTokens['--color-accent-olive-100'],
  '--semantic-border-accent-orchid-subtle': unityPrimitiveColorTokens['--color-accent-orchid-100'],
  '--semantic-border-accent-palatinate-blue-subtle': unityPrimitiveColorTokens['--color-accent-palatinate-blue-100'],
  '--semantic-border-accent-persimmon-subtle': unityPrimitiveColorTokens['--color-accent-persimmon-100'],
  '--semantic-border-accent-pink-flamingo-subtle': unityPrimitiveColorTokens['--color-accent-pink-flamingo-100'],
  '--semantic-border-accent-rackley-subtle': unityPrimitiveColorTokens['--color-accent-rackley-100'],
  '--semantic-border-accent-raspberry-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-100'],
  '--semantic-border-accent-royal-fuchsia-subtle': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-100'],
  '--semantic-border-accent-skyblue-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-100'],
  '--semantic-border-accent-sushi-green-subtle': unityPrimitiveColorTokens['--color-accent-sushi-green-100'],
  '--semantic-border-accent-vodka-subtle': unityPrimitiveColorTokens['--color-accent-vodka-100'],
  // semantic / border / interactive
  '--semantic-border-interactive-ai-start': unityPrimitiveColorTokens['--color-accent-turquoise-500'],
  // semantic / data / informative
  '--semantic-data-informative-unknown': unityPrimitiveColorTokens['--color-accent-dusty-gray-500'],
  // semantic / data / severity
  '--semantic-data-severity-critical': unityPrimitiveColorTokens['--color-red-800'],
  '--semantic-data-severity-critical-subtle': unityPrimitiveColorTokens['--color-red-100'],
  '--semantic-data-severity-high': unityPrimitiveColorTokens['--color-red-600'],
  '--semantic-data-severity-high-subtle': unityPrimitiveColorTokens['--color-accent-raspberry-50'],
  '--semantic-data-severity-info': unityPrimitiveColorTokens['--color-accent-dusty-gray-500'],
  '--semantic-data-severity-info-subtle': unityPrimitiveColorTokens['--color-accent-dusty-gray-50'],
  '--semantic-data-severity-low': unityPrimitiveColorTokens['--color-accent-sky-blue-600'],
  '--semantic-data-severity-low-subtle': unityPrimitiveColorTokens['--color-accent-sky-blue-50'],
  '--semantic-data-severity-mid': unityPrimitiveColorTokens['--color-orange-700'],
  '--semantic-data-severity-mid-subtle': unityPrimitiveColorTokens['--color-orange-100'],
  '--semantic-data-severity-neutral': unityPrimitiveColorTokens['--color-charcoal-300'],
  // semantic / text
  '--semantic-text-ai-highlight': unityPrimitiveColorTokens['--color-accent-turquoise-800'],
  '--semantic-text-highlight': unityPrimitiveColorTokens['--color-brand-900'],
  '--semantic-text-link': unityPrimitiveColorTokens['--color-blue-800'],
  '--semantic-text-link-hover': unityPrimitiveColorTokens['--color-blue-600'],
  '--semantic-text-success': unityPrimitiveColorTokens['--color-green-800'],
  '--semantic-text-warning': unityPrimitiveColorTokens['--color-orange-900'],
  // semantic / text / accent
  '--semantic-text-accent-ai': unityPrimitiveColorTokens['--color-accent-turquoise-900'],
  '--semantic-text-accent-max-yellow': unityPrimitiveColorTokens['--color-accent-maximum-yellow-900'],
  '--semantic-text-accent-olive': unityPrimitiveColorTokens['--color-accent-olive-900'],
  '--semantic-text-accent-orchid': unityPrimitiveColorTokens['--color-accent-orchid-900'],
  '--semantic-text-accent-palatinate-blue': unityPrimitiveColorTokens['--color-accent-palatinate-blue-900'],
  '--semantic-text-accent-persimmon': unityPrimitiveColorTokens['--color-accent-persimmon-900'],
  '--semantic-text-accent-pink-flamingo': unityPrimitiveColorTokens['--color-accent-pink-flamingo-900'],
  '--semantic-text-accent-rackley': unityPrimitiveColorTokens['--color-accent-rackley-900'],
  '--semantic-text-accent-raspberry': unityPrimitiveColorTokens['--color-accent-raspberry-900'],
  '--semantic-text-accent-royal-fuchsia': unityPrimitiveColorTokens['--color-accent-royal-fuchsia-900'],
  '--semantic-text-accent-skyblue': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--semantic-text-accent-sushi-green': unityPrimitiveColorTokens['--color-accent-sushi-green-900'],
  '--semantic-text-accent-vodka': unityPrimitiveColorTokens['--color-accent-vodka-900'],
} satisfies Record<string, HexColor>;

export const unitySemanticDarkColorTokens = {
  // semantic / text
  '--semantic-text-bold': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-text-default': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--semantic-text-disabled': unityPrimitiveColorTokens['--color-charcoal-500'],
  '--semantic-text-info': unityPrimitiveColorTokens['--color-accent-sky-blue-500'],
  '--semantic-text-inverse': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-text-placeholder': unityPrimitiveColorTokens['--color-charcoal-400'],
  '--semantic-text-destructive': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-text-contrast': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-text-selected': unityPrimitiveColorTokens['--color-purple-500'],
  // semantic / bg / status
  '--semantic-bg-status-highlight': unityPrimitiveColorTokens['--color-brand-600'],
  // semantic / bg / surface
  '--semantic-bg-surface-base': unityPrimitiveColorTokens['--color-malibu-1000'],
  '--semantic-bg-surface-backdrop': '#0A0E15',
  '--semantic-bg-surface-floating': unityPrimitiveColorTokens['--color-charcoal-900'],
  '--semantic-bg-surface-page-container': unityPrimitiveColorTokens['--color-malibu-950'],
  '--semantic-bg-surface-overlay': unityPrimitiveColorTokens['--color-charcoal-900'],
  // semantic / bg / input
  '--semantic-bg-input-default': unityPrimitiveColorTokens['--color-charcoal-700'],
  '--semantic-bg-input-active': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--semantic-bg-input-disabled': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-bg-input-inverse': unityPrimitiveColorTokens['--color-malibu-200'],
  '--semantic-bg-input-inverse-hover': unityPrimitiveColorTokens['--color-malibu-300'],
  // semantic / bg / interactive / neutral
  '--semantic-bg-interactive-neutral-default': unityPrimitiveColorTokens['--color-charcoal-700'],
  '--semantic-bg-interactive-neutral-hover': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--semantic-bg-interactive-neutral-active': unityPrimitiveColorTokens['--color-charcoal-600'],
  '--semantic-bg-interactive-neutral-disabled': unityPrimitiveColorTokens['--color-charcoal-950'],
  '--semantic-bg-interactive-neutral-focus': unityPrimitiveColorTokens['--color-charcoal-950'],
  // semantic / bg / interactive / highlight
  '--semantic-bg-interactive-highlight-default': unityPrimitiveColorTokens['--color-brand-600'],
  '--semantic-bg-interactive-highlight-hover': unityPrimitiveColorTokens['--color-brand-400'],
  // semantic / bg / interactive / destructive
  '--semantic-bg-interactive-destructive-default': unityPrimitiveColorTokens['--color-red-600'],
  '--semantic-bg-interactive-destructive-hover': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-bg-interactive-destructive-disabled': unityPrimitiveColorTokens['--color-charcoal-950'],
  '--semantic-bg-interactive-destructive-subtle-default': unityPrimitiveColorTokens['--color-red-950'],
  // semantic / border
  '--semantic-border-default': unityPrimitiveColorTokens['--color-charcoal-700'],
  '--semantic-border-bold': unityPrimitiveColorTokens['--color-charcoal-500'],
  '--semantic-border-emphasized': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--semantic-border-disabled': unityPrimitiveColorTokens['--color-charcoal-800'], // changed from charcoal-950
  '--semantic-border-inverse': unityPrimitiveColorTokens['--color-charcoal-100'],
  // semantic / data / informative
  '--semantic-data-informative-negative': unityPrimitiveColorTokens['--color-red-600'],
  '--semantic-data-informative-informative': unityPrimitiveColorTokens['--color-accent-sky-blue-500'],
  '--semantic-data-informative-positive': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-data-informative-intermediate': unityPrimitiveColorTokens['--color-orange-500'],
  '--semantic-data-informative-neutral': unityPrimitiveColorTokens['--color-charcoal-400'], // changed from charcoal-600
} satisfies Record<SemanticColorKey, HexColor>;

export const unitySemanticLightColorTokens = {
  // semantic / text
  '--semantic-text-bold': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-text-default': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--semantic-text-disabled': unityPrimitiveColorTokens['--color-charcoal-400'],
  '--semantic-text-info': unityPrimitiveColorTokens['--color-accent-sky-blue-800'],
  '--semantic-text-inverse': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-text-placeholder': unityPrimitiveColorTokens['--color-charcoal-500'],
  '--semantic-text-destructive': unityPrimitiveColorTokens['--color-red-800'],
  '--semantic-text-contrast': unityPrimitiveColorTokens['--color-charcoal-1000'],
  '--semantic-text-selected': unityPrimitiveColorTokens['--color-purple-600'],
  // semantic / bg / status
  '--semantic-bg-status-highlight': unityPrimitiveColorTokens['--color-brand-700'], // changed from brand-600
  // semantic / bg / surface
  '--semantic-bg-surface-base': unityPrimitiveColorTokens['--color-malibu-200'],
  '--semantic-bg-surface-backdrop': '#172D4F',
  '--semantic-bg-surface-floating': unityPrimitiveColorTokens['--color-malibu-50'],
  '--semantic-bg-surface-page-container': unityPrimitiveColorTokens['--color-malibu-50'],
  '--semantic-bg-surface-overlay': unityPrimitiveColorTokens['--color-malibu-100'],
  // semantic / bg / input
  '--semantic-bg-input-default': unityPrimitiveColorTokens['--color-charcoal-100'], // changed from charcoal-50
  '--semantic-bg-input-active': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--semantic-bg-input-disabled': unityPrimitiveColorTokens['--color-charcoal-50'],
  '--semantic-bg-input-inverse': unityPrimitiveColorTokens['--color-malibu-950'],
  '--semantic-bg-input-inverse-hover': unityPrimitiveColorTokens['--color-malibu-800'],
  // semantic / bg / interactive / neutral
  '--semantic-bg-interactive-neutral-default': unityPrimitiveColorTokens['--color-charcoal-100'], // changed from charcoal-50
  '--semantic-bg-interactive-neutral-hover': unityPrimitiveColorTokens['--color-charcoal-200'], // changed from charcoal-100
  '--semantic-bg-interactive-neutral-active': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--semantic-bg-interactive-neutral-disabled': unityPrimitiveColorTokens['--color-charcoal-100'], // changed from charcoal-50
  '--semantic-bg-interactive-neutral-focus': unityPrimitiveColorTokens['--color-charcoal-300'],
  // semantic / bg / interactive / highlight
  '--semantic-bg-interactive-highlight-default': unityPrimitiveColorTokens['--color-malibu-900'],
  '--semantic-bg-interactive-highlight-hover': unityPrimitiveColorTokens['--color-charcoal-700'],
  // semantic / bg / interactive / destructive
  '--semantic-bg-interactive-destructive-default': unityPrimitiveColorTokens['--color-red-600'],
  '--semantic-bg-interactive-destructive-hover': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-bg-interactive-destructive-disabled': unityPrimitiveColorTokens['--color-charcoal-100'], // changed from charcoal-50
  '--semantic-bg-interactive-destructive-subtle-default': unityPrimitiveColorTokens['--color-red-50'],
  // semantic / border
  '--semantic-border-default': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--semantic-border-bold': unityPrimitiveColorTokens['--color-charcoal-300'],
  '--semantic-border-emphasized': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--semantic-border-disabled': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--semantic-border-inverse': unityPrimitiveColorTokens['--color-charcoal-950'],
  // semantic / data / informative
  '--semantic-data-informative-negative': unityPrimitiveColorTokens['--color-red-500'],
  '--semantic-data-informative-informative': unityPrimitiveColorTokens['--color-accent-sky-blue-500'],
  '--semantic-data-informative-positive': unityPrimitiveColorTokens['--color-green-500'],
  '--semantic-data-informative-intermediate': unityPrimitiveColorTokens['--color-orange-500'],
  '--semantic-data-informative-neutral': unityPrimitiveColorTokens['--color-charcoal-400'], // changed from charcoal-300
} satisfies Record<SemanticColorKey, HexColor>;

export const xcorDefinedLightTokens = {
  '--bg-row-hover': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--bg-row-active': unityPrimitiveColorTokens['--color-charcoal-200'],
  '--data-informative-informative-high-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-800'],
  '--data-informative-informative-low-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-100'],
  '--data-informative-intermediate-high-contrast': unityPrimitiveColorTokens['--color-orange-900'],
  '--data-informative-intermediate-low-contrast': unityPrimitiveColorTokens['--color-orange-100'],
  '--data-informative-negative-high-contrast': unityPrimitiveColorTokens['--color-red-900'],
  '--data-informative-negative-low-contrast': unityPrimitiveColorTokens['--color-red-100'],
  '--data-informative-neutral-high-contrast': unityPrimitiveColorTokens['--color-charcoal-600'],
  '--data-informative-neutral-low-contrast': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--data-informative-new': unityPrimitiveColorTokens['--color-accent-vodka-500'],
  '--data-informative-new-high-contrast': unityPrimitiveColorTokens['--color-accent-vodka-700'],
  '--data-informative-new-low-contrast': unityPrimitiveColorTokens['--color-accent-vodka-100'],
  '--data-informative-positive-high-contrast': unityPrimitiveColorTokens['--color-green-800'],
  '--data-informative-positive-low-contrast': unityPrimitiveColorTokens['--color-green-100'],
  '--primary-color-high-contrast': unityPrimitiveColorTokens['--color-brand-900'],
  '--primary-color-low-contrast': unityPrimitiveColorTokens['--color-brand-100'],
  '--primary-color-main': unityPrimitiveColorTokens['--color-brand-800'],
  '--secondary-color-high-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--secondary-color-low-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-200'],
  '--secondary-color-main': unityPrimitiveColorTokens['--color-accent-sky-blue-800'],
  '--syntax-tags-strong': unityPrimitiveColorTokens['--color-accent-sky-blue-800'],
  '--syntax-tags-bool': unityPrimitiveColorTokens['--color-orange-800'],
  '--syntax-tags-string': unityPrimitiveColorTokens['--color-green-800'],
  '--syntax-tags-name-red': unityPrimitiveColorTokens['--color-red-800'],
  '--syntax-tags-name-green': unityPrimitiveColorTokens['--color-green-800'],
  '--syntax-tags-keyword': unityPrimitiveColorTokens['--color-purple-800'],
  '--syntax-tags-comment': unityPrimitiveColorTokens['--color-charcoal-800'],
} satisfies Record<XcorColorKey, HexColor>;

export const xcorDefinedDarkTokens = {
  '--bg-row-hover': unityPrimitiveColorTokens['--color-charcoal-800'],
  '--bg-row-active': unityPrimitiveColorTokens['--color-charcoal-600'],
  '--data-informative-informative-high-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-100'],
  '--data-informative-informative-low-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--data-informative-intermediate-high-contrast': unityPrimitiveColorTokens['--color-orange-100'],
  '--data-informative-intermediate-low-contrast': unityPrimitiveColorTokens['--color-orange-900'],
  '--data-informative-negative-high-contrast': unityPrimitiveColorTokens['--color-red-100'],
  '--data-informative-negative-low-contrast': unityPrimitiveColorTokens['--color-red-900'],
  '--data-informative-neutral-high-contrast': unityPrimitiveColorTokens['--color-charcoal-100'],
  '--data-informative-neutral-low-contrast': unityPrimitiveColorTokens['--color-charcoal-600'],
  '--data-informative-new': unityPrimitiveColorTokens['--color-accent-vodka-400'],
  '--data-informative-new-high-contrast': unityPrimitiveColorTokens['--color-accent-vodka-100'],
  '--data-informative-new-low-contrast': unityPrimitiveColorTokens['--color-accent-vodka-800'],
  '--data-informative-positive-high-contrast': unityPrimitiveColorTokens['--color-green-100'],
  '--data-informative-positive-low-contrast': unityPrimitiveColorTokens['--color-green-900'],
  '--primary-color-high-contrast': unityPrimitiveColorTokens['--color-brand-600'],
  '--primary-color-low-contrast': unityPrimitiveColorTokens['--color-brand-900'],
  '--primary-color-main': unityPrimitiveColorTokens['--color-brand-700'],
  '--secondary-color-high-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-300'],
  '--secondary-color-low-contrast': unityPrimitiveColorTokens['--color-accent-sky-blue-900'],
  '--secondary-color-main': unityPrimitiveColorTokens['--color-accent-sky-blue-600'],
  '--syntax-tags-strong': unityPrimitiveColorTokens['--color-accent-sky-blue-500'],
  '--syntax-tags-bool': unityPrimitiveColorTokens['--color-orange-600'],
  '--syntax-tags-string': unityPrimitiveColorTokens['--color-green-400'],
  '--syntax-tags-name-red': unityPrimitiveColorTokens['--color-red-400'],
  '--syntax-tags-name-green': unityPrimitiveColorTokens['--color-green-400'],
  '--syntax-tags-keyword': unityPrimitiveColorTokens['--color-purple-400'],
  '--syntax-tags-comment': unityPrimitiveColorTokens['--color-charcoal-400'],
} satisfies Record<XcorColorKey, HexColor>;

const globallyAccessibleTokens: Record<string, string> = {
  '--font-family-sans': 'Figtree',
  '--semantic-bg-status-highlight-light': unitySemanticLightColorTokens['--semantic-bg-status-highlight'],
  '--semantic-bg-status-highlight-dark': unitySemanticDarkColorTokens['--semantic-bg-status-highlight'],
};

/** Tokens exported for usage outside of chrono-ui */
export const unityTokens: Record<string, string> = globallyAccessibleTokens;

/** Keys present in light/dark semantic color token maps (union covers any theme-only key differences). */
export type UnitySemanticColorTokenName =
  | keyof typeof unitySemanticLightColorTokens
  | keyof typeof unitySemanticDarkColorTokens;

/** Keys present in light/dark XCOR token maps used for component palette resolution. */
export type XcorDefinedColorTokenName = keyof typeof xcorDefinedLightTokens | keyof typeof xcorDefinedDarkTokens;

/** Semantic or XCOR dictionary keys accepted in component palette `Token.tokenName`. */
export type PanwDictionaryColorTokenName = UnitySemanticColorTokenName | XcorDefinedColorTokenName;

export const unityRadiusTokens: Record<string, string> = {
  '--border-radius-xs': '4px',
  '--border-radius-sm': '6px',
  '--border-radius-md': '8px',
  '--border-radius-lg': '12px',
  '--border-radius-xl': '16px',
};

const _unityTransitionTokens: Record<string, string> = {
  '--transition-timing-function-linear': ' Linear',
  '--transition-timing-function-in-out': 'cubic-bezier(0.83, 0, 0.17, 1)',
  '--transition-timing-function-in': 'cubic-bezier(0.64, 0, 0.78, 0)',
  '--transition-timing-function-out': 'cubic-bezier(0.22, 1, 0.36, 1)',
};

const _unitySizingTokens: Record<string, string> = {
  '--spacing-0': ' 0px',
  '--spacing-1': ' 4px',
  '--spacing-2': ' 8px',
  '--spacing-3': ' 12px',
  '--spacing-4': ' 16px',
  '--spacing-5': '20px',
  '--spacing-6': '24px',
  '--spacing-7': '28px',
  '--spacing-8': '32px',
  '--spacing-9': '36px',
  '--spacing-10': '40px',
  '--spacing-11': '44px',
  '--spacing-12': '48px',
  '--spacing-14': '56px',
  '--spacing-16': '64px',
  '--spacing-18': '72px',
  '--spacing-20': '80px',
  '--spacing-22': '88px',
  '--spacing-24': '96px',
  '--spacing-32': '128px',
  '--spacing-40': '160px',
  '--spacing-50': '200px',
  '--spacing-64': '256px',
  '--spacing-74': '296px',
  '--spacing-80': '320px',
  '--spacing-100': '400px',
  '--spacing-120': '480px',
  '--spacing-140': '560px',
  '--spacing-160': '640px',
  '--spacing-180': '720px',
  '--spacing-210': '840px',
  '--spacing-256': '1024px',
  '--spacing-320': '1280px',
  '--spacing-360': '1440px',
  '--spacing-480': '1920px',
  '--spacing-0-5': '2px',
  '--spacing-1-5': '6px',
  '--spacing-2-5': '10px',
  '--spacing-px': '1px',
  '--spacing-3-5': '14px',
  '--shadow-offset-y-md': '4px',
  '--shadow-offset-y-sm': '4px',
  '--shadow-offset-y-lg': '-4px',
  '--shadow-offset-y-content-shell': '-16px',
  '--shadow-blur-radius-lg': '40px',
  '--shadow-blur-radius-md': '32px',
  '--shadow-blur-radius-sm': '12px',
  '--shadow-blur-radius-content-shell': '40px',
  '--shadow-offset-x-md': '0px',
  '--shadow-offset-x-lg': '0px',
  '--shadow-offset-x-sm': '0px',
  '--shadow-offset-x-content-shell': '0px',
  '--shadow-spread-radius-sm': '4px',
  '--shadow-spread-radius-md': '8px',
  '--shadow-spread-radius-lg': '0px',
  '--shadow-spread-radius-content-shell': '-16px',
  '--ring-width-0': '0px',
  '--ring-width-2': '2px',
  '--font-weight-medium': '500',
  '--font-weight-semibold': '600',
  '--font-weight-bold': '700',
  '--font-weight-light': '300',
  '--font-weight-normal': '400',
  '--font-size-xs': '12px',
  '--font-size-sm': '16px',
  '--font-size-lg': '20px',
  '--font-size-xl': '24px',
  '--font-size-2xl': '28px',
  '--font-size-3xl': '32px',
  '--font-size-4xl': '36px',
  '--font-size-5xl': '48px',
  '--font-size-6xl': '56px',
  '--font-size-7xl': '72px',
  '--font-size-8xl': '96px',
  '--font-size-base': '14px',
  '--font-size-md': '18px',
  '--line-height-xs': '16px',
  '--line-height-base': '20px',
  '--line-height-sm': '24px',
  '--line-height-lg': '28px',
  '--line-height-xl': '32px',
  '--line-height-2xl': '36px',
  '--line-height-3xl': '40px',
  '--line-height-4xl': '48px',
  '--line-height-5xl': '64px',
  '--line-height-6xl': '72px',
  '--line-height-7xl': '96px',
  '--line-height-8xl': '120px',
  '--line-height-md': '24px',
  '--letter-spacing-0': '0px',
  '--letter-spacing-xs': '1px',
  '--letter-spacing-sm': '2px',
  '--letter-spacing-md': '-1px',
};
